import {svg} from '../../svg.ts';
import {html, htmlRaw} from '../../utils/html.ts';
import {createElementFromHTML} from '../../utils/dom.ts';
import {showFomanticModal} from '../../modules/fomantic/modal.ts';
import {hideToastsAll} from '../../modules/toast.ts';

const {i18n} = window.config;

type ConfirmModalOptions = {
  header?: string;
  content?: string;
  confirmButtonColor?: 'primary' | 'red' | 'green' | 'blue';
  cancelText?: string;
  confirmText?: string | null;
  // the cancel button becomes the primary, focused action; the confirm button is plain or hidden (null)
  preferCancel?: boolean;
};

export function createConfirmModal({header = '', content = '', confirmButtonColor = 'primary', cancelText = i18n.modal_cancel, confirmText = i18n.modal_confirm, preferCancel = false}:ConfirmModalOptions = {}): HTMLElement {
  const headerHtml = header ? html`<div class="header">${header}</div>` : '';
  if (preferCancel) {
    const confirmHtml = confirmText === null ? '' : html`<button class="ui ok button">${confirmText}</button>`;
    return createElementFromHTML(html`
      <div class="ui g-modal-confirm modal">
        ${htmlRaw(headerHtml)}
        <div class="content">${content}</div>
        <div class="actions">
          ${htmlRaw(confirmHtml)}
          <button class="ui primary cancel button" autofocus>${cancelText}</button>
        </div>
      </div>
    `.trim());
  }
  return createElementFromHTML(html`
    <div class="ui g-modal-confirm modal">
      ${htmlRaw(headerHtml)}
      <div class="content">${content}</div>
      <div class="actions">
        <button class="ui cancel button">${htmlRaw(svg('octicon-x'))} ${cancelText}</button>
        <button class="ui ${confirmButtonColor} ok button" autofocus>${htmlRaw(svg('octicon-check'))} ${confirmText ?? i18n.modal_confirm}</button>
      </div>
    </div>
  `.trim());
}

export function confirmModal(modal: HTMLElement | ConfirmModalOptions): Promise<boolean> {
  if (!(modal instanceof HTMLElement)) modal = createConfirmModal(modal);
  // hide existing toasts when we need to show a new modal, otherwise the toasts only interfere the UI
  // it's fine to do so because the modal is triggered by user's explicit action, so the user should already have read the toast messages
  hideToastsAll();
  return new Promise((resolve) => {
    showFomanticModal(modal, {
      onApprove() {
        resolve(true);
      },
      onHidden() {
        modal.remove();
        resolve(false);
      },
    });
  });
}
